<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="step-personal-data">
        <loader v-if="loading">
            Sprawdzam dane
        </loader>

        <form id="personal-data-form" v-on:submit.prevent="submit" v-if="!loading">

            <div class="inputs-section">
                <div class="form-row nick-gender">
                    <input-group v-model="form.nick" :val="form.nick" class-name="nick" name="nick" placeholder="Twój nick"
                                 :valid="errors.nick">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>
                    <div class="form-group gender">
                        <input-group v-model="form.gender" :val="form.gender" type="gender"/>
                    </div>
                </div>
                <form-error :show="true" class="gender-error" v-if="!errors.gender">
                    <template v-slot:errorMessage>
                        Uzupełnij płeć
                    </template>
                </form-error>
                <div class="form-row half-half">
                    <input-group v-model="form.firstName" :val="form.firstName" name="firstname" placeholder="Imię"
                                 :valid="errors.firstName">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>
                    <input-group v-model="form.lastName" :val="form.lastName" name="lastname" placeholder="Nazwisko"
                                 :valid="errors.lastName">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>
                </div>
                <div class="form-row">
                    <input-group v-model="form.email" :val="form.email" name="email" placeholder="E-mail" :valid="errors.email">
                        <template v-slot:errorMessage>
                            {{ emailWrong ? 'Podany adres jest zajęty' : 'Podaj poprawny adres' }}
                        </template>
                    </input-group>
                </div>

                <div class="phone form-row">
                    <input-group v-model="form.phone" :val="form.phone" type="phone" class="detached-error"
                                 :valid="errors.phone">
                        <template v-slot:errorMessage>Podaj poprawny numer telefonu</template>
                    </input-group>
                </div>


                <div class="form-row half-half">
                    <input-group v-model="form.city" :val="form.city" name="city" placeholder="Miasto" :valid="errors.city">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>


                    <input-group v-model="form.country" :val="form.country" name="country" type="select" :valid="errors.country"
                                 :options="getCountries()">
                        <template v-slot:errorMessage>Wybierz kraj</template>
                    </input-group>
                </div>

                <div class="date form-row">
                    <input-group v-model="form.birthDate" :val="form.birthDate" type="date" class="detached-error"
                                 :valid="errors.birthDate">
                        <template v-slot:errorMessage>Podaj poprawną datę urodzenia</template>
                    </input-group>
                </div>

                <div class="form-row submit-data text-center">
                    <button type="submit" class="submit-purple-button">Zapisz dane</button>
                </div>
            </div>

            <div class="form-row terms" id="terms-box">

                <input-group id="1" v-model="form.terms.first" :val="form.terms.first" type="term"
                             class="detached-error term" :valid="errors.terms.first">
                    <template v-slot:errorMessage>Zgoda jest wymagana</template>
                    <template v-slot:label>Oświadczam, że zapoznałem się z i akceptuję <a target="_blank" href="https://influencerzy.friendsandbrands.pl/terms/Friends&Brands_Regulamin.pdf">Regulamin</a> serwisu.
                    </template>
                </input-group>

                <input-group id="2" v-model="form.terms.second" :val="form.terms.second" type="term"
                             class="detached-error term" :valid="errors.terms.second">
                    <template v-slot:errorMessage>Zgoda jest wymagana</template>
                    <template v-slot:label>
                        Wyrażam zgodę na przetwarzanie przesłanych danych osobowych przez Faster&Better sp. z o.o., z
                        siedzibą w Warszawie, ul. Wolska 88, 01-141 Warszawa, z przeznaczeniem
                        do wykorzystania ich w celach marketingowych Oświadczam,
                        że zostałem poinformowany o dobrowolności podania danych,
                        jak również o przysługujących prawach do dostępu do danych, możliwości ich poprawiania lub żądania
                        ich usunięcia.
                    </template>
                </input-group>

                <input-group id="3" v-model="form.terms.third" :val="form.terms.third" type="term"
                             class="detached-error term" :valid="errors.terms.third">
                    <template v-slot:errorMessage>Zgoda jest wymagana</template>
                    <template v-slot:label>
                        Wyrażam zgodę na otrzymywanie od Faster&Better sp. z o.o.,
                        z siedzibą w Warszawie, 01-141, ul. Wolska 88, informacji o kampaniach drogą
                        elektroniczną i telefoniczną.
                    </template>
                </input-group>
            </div>

        </form>
    </div>
</template>

<script>
    import InputGroup from "./elements/InputGroup";
    import countries from '../../assets/countries.json';
    import SmoothScroll from 'smooth-scroll';
    import Router from '../../routing';
    import Loader from "../Loader";
    import FormError from "./elements/FormError";

    export default {
        components: {
            FormError,
            Loader,
            InputGroup
        },
        name: "step-personal-data",
        mounted: function () {

        },
        props: ['form'],
        data: function () {
            return {
                loading: false,
                emailWrong: false,
                errors: {
                    nick: true,
                    firstName: true,
                    lastName: true,
                    email: true,
                    phone: true,
                    gender: true,
                    city: true,
                    country: true,
                    birthDate: true,
                    terms: {
                        first: true,
                        second: true,
                        third: true
                    }
                }
            }
        },
        methods: {
            getCountries: function () {
                let result = [];

                result.push({
                    label: 'Kraj',
                    value: ''
                });

                for (let i = 0; i < countries.length; i++) {
                    result.push({
                        label: countries[i],
                        value: countries[i]
                    });
                }

                return result;
            },
            validateLength: function (value, lengthMin, lengthMax) {
                if (value.length < lengthMin) return false;
                if (value.length > lengthMax) return false;

                return true;
            },
            validateEmail: function () {
                let re = /\S+@\S+\.\S+/;
                return re.test(this.form.email);
            },
            validateDate: function () {
                if (this.form.birthDate.day.length < 1) return false;
                if (this.form.birthDate.month.length < 1) return false;
                if (this.form.birthDate.year.length !== 4) return false;

                return true;
            },
            formIsValid: function () {
                if (!this.errors.nick) return 'form';
                if (!this.errors.firstName) return 'form';
                if (!this.errors.lastName) return 'form';
                if (!this.errors.email) return 'form';
                if (!this.errors.phone) return 'form';
                if (!this.errors.city) return 'form';
                if (!this.errors.country) return 'form';
                if (!this.errors.birthDate) return 'form';
                if (!this.errors.gender) return 'form';

                if (!this.errors.terms.first) return 'terms';
                if (!this.errors.terms.second) return 'terms';
                if (!this.errors.terms.third) return 'terms';

                return true;
            },
            submit: function () {
                this.fullValidate();

                let isValid = this.formIsValid();

                if (isValid === true) {
                    this.loading = true;
                    this.$http.post(Router.generate('check_email'),{email: this.form.email}, Router.getAuthHeader())
                        .then(response => {
                            if(response.body.status) {
                                this.emailWrong = false;
                                this.finalCheck();
                            }
                            else {
                                this.errors.email = false;
                                this.emailWrong = true;
                            }

                            this.loading = false;
                        }, response => {
                            this.loading = false;
                            Router.handleWrongRequest(response);
                        });
                }
                else if (isValid === 'form') {
                    let scroll = new SmoothScroll();
                    let anchor = document.body;

                    scroll.animateScroll(anchor, null, {updateURL: false});
                    this.triggerError();
                }
                else if (isValid === 'terms') {
                    let scroll = new SmoothScroll();
                    let anchor = document.getElementById('terms-box');

                    scroll.animateScroll(anchor, null, {updateURL: false});
                    this.triggerError();
                }



                return false;
            },
            finalCheck: function () {
                this.$emit('submit-data', this.form);
            },
            triggerError: function() {
                this.$notify({
                    group: 'form',
                    type: 'warn',
                    title: 'Formularz zawiera błędy'
                });
            },
            fullValidate: function () {
                this.emailWrong = false;

                this.errors.nick = this.validateLength(this.form.nick, 1);
                this.errors.firstName = this.validateLength(this.form.firstName, 1);
                this.errors.lastName = this.validateLength(this.form.lastName, 1);
                this.errors.email = this.validateEmail();
                this.errors.phone = this.validateLength(this.form.phone.number, 1);
                this.errors.city = this.validateLength(this.form.city, 1);
                this.errors.country = this.validateLength(this.form.country, 1);
                this.errors.birthDate = this.validateDate();
                this.errors.gender = (this.form.gender === 1 || this.form.gender === 0);

                this.errors.terms.first = this.form.terms.first;
                this.errors.terms.second = this.form.terms.second;
                this.errors.terms.third = this.form.terms.third;
            }
        },
        watch: {
            "form.gender": function () {
                this.errors.gender = true;
            },
            "form.nick": function () {
                this.errors.nick = true;
                this.errors.nick = this.validateLength(this.form.nick, 1);
            },
            "form.firstName": function () {
                this.errors.firstName = true;
                this.errors.firstName = this.validateLength(this.form.firstName, 1);
            },
            "form.lastName": function () {
                this.errors.lastName = true;
                this.errors.lastName = this.validateLength(this.form.lastName, 1);
            },
            "form.email": function () {
                this.errors.email = true;
                this.errors.email = this.validateLength(this.form.email, 1);
            },
            "form.phone.number": function () {
                this.errors.phone = true;
                this.errors.phone = this.validateLength(this.form.phone.number, 1);
            },
            "form.city": function () {
                this.errors.city = true;
                this.errors.city = this.validateLength(this.form.city, 1);
            },
            "form.country": function () {
                this.errors.country = true;
                this.errors.country = this.validateLength(this.form.country, 1);
            },
            "form.birthDate.day": function () {
                this.errors.birthDate = true;
                this.errors.birthDate = this.validateLength(this.form.birthDate.day, 1);
            },
            "form.birthDate.month": function () {
                this.errors.birthDate = true;
                this.errors.birthDate = this.validateLength(this.form.birthDate.month, 1);
            },
            "form.birthDate.year": function () {
                this.errors.birthDate = true;
                this.errors.birthDate = this.validateLength(this.form.birthDate.year, 1);
            },
            "form.terms.first": function () {
                this.errors.terms.first = this.form.terms.first;
            },
            "form.terms.second": function () {
                this.errors.terms.second = this.form.terms.second;
            },
            "form.terms.third": function () {
                this.errors.terms.third = this.form.terms.third;
            }
        }
    }
</script>

<style lang="scss">
    .terms {
        .term {
            margin-top: 10px;
        }
    }
</style>

<style scoped lang="scss">

</style>
